window.onload = (event) => {
  console.log("page is fully loaded");
};


// document.addEventListener("DOMContentLoaded", function () {

//             const cartLink = document.querySelector("a.navlink.navlink--cart");
//             console.log(cartLink)
//                 cartLink.click();
//                 console.log("Cart link found, triggering click:", cartLink);
// });



// document.addEventListener("DOMContentLoaded", function () {
//     console.log("DOM fully loaded and parsed");

//     document.body.addEventListener("click", function (event) {
//         console.log("Click detected on:", event.target);

//         const addToCartButton = event.target.closest("#add-to-cart--btn");
//         if (!addToCartButton) {
//             console.log("Clicked element is not the Add to Cart button");
//             return;
//         }

//         console.log("Add to Cart button clicked:", addToCartButton);

//         setTimeout(function () {
//             console.log("1.5 second passed — now trying to open cart");

//             const cartLink = document.querySelector("a.navlink.navlink--cart");
//             if (cartLink) {
//                 console.log("Cart link found, triggering click:", cartLink);
//                 cartLink.click();
//             } else {
//                 console.warn("Cart link not found on page");
//             }
//         }, 2000);
//     });
// });